import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import EnterIcon from '~app/components/SVG/EnterIcon';
import ArrowBackIcon from '~app/components/SVG/ArrowBackIcon';
import ArrowForwardIcon from '~app/components/SVG/ArrowForwardIcon';
import { useT } from "~app/BundleProvider";

const Prev = ({ prev }) => {
  const t = useT();
  return (
    <div role="button" aria-label={t("previous-page")} tabIndex="0" className="arrow-div" onClick={() => prev()}
    onKeyPress={(event) => {
        if(event.key === 'Enter' || event.key === ' '){
          prev();
        }
      }}>
      <ArrowBackIcon className="arrow arrow-back" />
    </div>
  );
};

const Next = ({ next }) => {
  const t = useT();
  return (
    <div role="button" aria-label={t("next-page")} tabIndex="0" className="arrow-div" onClick={() => next()}
    onKeyPress={(event) => {
        if(event.key === 'Enter' || event.key === ' '){
          next();
        }
      }}>
      <ArrowForwardIcon className="arrow arrow-forward" />
    </div>
  );
};

const Last = () => {
  const t = useT();
  return (
    <div className="last-div">
      <Link to="/main"  aria-label={t("continue-to-application")}>
        <EnterIcon className="enter-icon" />
      </Link>
    </div>
  );
};

const IntroNav = ({ prev, next, last, children }) => {
  return (
    <div className="page-nav">
      {prev ? <Prev prev={prev} /> : <div />}
      {children}
      {next &&  <Next next={next} />}
      {last && <Last />}
    </div>
  );
};

IntroNav.propTypes = {
  prev: PropTypes.func,
  next: PropTypes.func,
  last: PropTypes.bool,
};

export default IntroNav;



// WEBPACK FOOTER //
// ./src/pages/intro/IntroNav.js